import { animate, style, transition, trigger } from '@angular/animations';

export const ALPY_FLY_IN_ANIMATION = trigger('alpyIn', [
  transition(':enter', [
    style({ transform: 'translateX(calc(100% + 17px))' }),
    animate('800ms 900ms ease-in-out', style({ transform: 'translateX(0)' }))
  ])
]);
